export default __webpack_public_path__ + "static/media/full_face_smiling.75bd4ea7.svg";